module.exports = __webpack_public_path__ + "static/media/ic_banos_pin.54b98cf9.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_banos_pin.webp
// module id = 199
// module chunks = 1